import dynamic from "next/dynamic";

export const MultipleForms = dynamic(() => import("./component"));
